import { router } from "@inertiajs/react"
import { Star } from "lucide-react"
import { useState } from "react"
import { cn } from "@/lib/utils"

// Star a community, plan, or project from its page to keep it on Home.
export function StarButton({
  type,
  id,
  starred,
  className,
}: {
  type: "Community" | "Plan" | "Project"
  id: number
  starred: boolean
  className?: string
}) {
  const [busy, setBusy] = useState(false)
  const toggle = () => {
    setBusy(true)
    router.post(
      "/favorites",
      { favoritable_type: type, favoritable_id: id },
      { preserveScroll: true, onFinish: () => setBusy(false) },
    )
  }
  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      aria-label={starred ? `Unstar this ${type.toLowerCase()}` : `Star this ${type.toLowerCase()}`}
      aria-pressed={starred}
      className={cn(
        "inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-surface",
        className,
      )}
      data-testid={`star-${type.toLowerCase()}-${id}`}
    >
      <Star
        className={cn("h-4 w-4", starred ? "fill-accent stroke-accent" : "stroke-ink-muted")}
      />
    </button>
  )
}
